import {
	createSlice,
	current
} from '@reduxjs/toolkit';
import {
	getManagementList,
	addNewManagement,
	updateManagement,
	deleteManagement,
	getManagement,
	getOrganizationalChart,
} from '../management/thunk';

export const initialState = {
	itemManagementList: [],
	itemManagementDetail: null,
	isManagementLoading: false,
	isManagementSuccess: false,

	managementList: [],
	managementListSelect: [],
	itemOrganizationalChart: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
};

const ManagementSlice = createSlice({
	name: 'Managements',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getManagement.fulfilled, (state, action) => {
			state.isManagementLoading = false;
			state.isManagementSuccess = true;
			state.itemManagementDetail = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getManagement.pending, state => {
			state.isManagementLoading = true;
			state.isManagementSuccess = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getManagement.rejected, (state, action) => {
			state.isManagementLoading = false;
			state.isManagementSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
		});

		builder.addCase(getManagementList.pending, state => {
			state.isManagementSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getManagementList.fulfilled, (state, action) => {
			state.itemManagementList = action.payload;
			state.managementList = action.payload;
			state.isLoadingList = false;
			state.isManagementSuccess = true;

			let managementListSelect = [];
			action.payload.map(item =>
				managementListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.managementListSelect = managementListSelect;
		});
		builder.addCase(getManagementList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isManagementSuccess = true;
		});
		builder.addCase(addNewManagement.fulfilled, (state, action) => {
			state.itemManagementList.push(action.payload);
			state.managementList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(addNewManagement.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewManagement.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});

		builder.addCase(updateManagement.fulfilled, (state, action) => {
			state.itemManagementList = state.itemManagementList.map(management =>
				management.managementname === action.payload.old_management
					? { ...management, ...action.payload.updated_management }
					: management
			);
			state.managementList = state.managementList.map(management =>
				management._id.toString() === action.payload._id.toString()
					? { ...management, ...action.payload }
					: management
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(updateManagement.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updateManagement.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteManagement.fulfilled, (state, action) => {
			state.itemManagementList = current(state.itemManagementList).filter(
				item => item._id !== action.payload._id
			);
			state.managementList = current(state.managementList).filter(item =>
				item._id !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
			state.requireCloseModal = true;
		});
		builder.addCase(deleteManagement.pending, (state, action) => {
			state.isLoadingList = true;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
		});
		builder.addCase(deleteManagement.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDelete = true;
		});



		builder.addCase(getOrganizationalChart.fulfilled, (state, action) => {
			state.isManagementLoading = false;
			state.isManagementSuccess = true;
			state.itemOrganizationalChart = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getOrganizationalChart.pending, state => {
			state.isManagementLoading = true;
			state.isManagementSuccess = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getOrganizationalChart.rejected, (state, action) => {
			state.isManagementLoading = false;
			state.isManagementSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
		});
	},
});

export const { setRequireCloseModal } = ManagementSlice.actions;

export default ManagementSlice.reducer;
